import classNames from 'classnames';
import {
  Button,
  FlexContainer,
  Txt,
  View,
  TenantDepositDetails,
} from 'components';
import { observer } from 'mobx-react-lite';
import { formatCurrency } from 'helpers/formatNumber';
import { useState } from 'react';
import { tdsLink } from 'config';
import { paymentTypes } from 'config/types';
import { useDataActions, useTenancy } from 'state';
import styles from './DepositNotLinked.module.scss';

/**
 * DepositNotLinked
 *
 * @return {JSX.Element}
 */
const DepositNotLinked = ({ className, onSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);
  const storageActions = useDataActions();
  const tenancyDoc = useTenancy();
  const { tenants: tenantsCollection } = tenancyDoc;

  const tenancyData = tenancyDoc.data;
  const tenantsData = tenantsCollection.data;

  const handleSendDepositReminder = () => {
    setIsLoading(true);
    storageActions.tenancy
      .sendDepositReminder(tenancyDoc, paymentTypes.DEPOSIT)
      .then(() => {
        if (onSuccess) {
          onSuccess();
        } else {
          setIsLoading(false);
        }
      })
      .catch((e) => {
        console.warn('Failed to send deposit reminder');
        console.error(e);
        setIsLoading(false);
      });
  };

  return (
    <FlexContainer
      className={classNames(
        styles.DepositNotLinked,
        className,
        DepositNotLinked.displayName
      )}
      gap
      column
    >
      <Txt bold>⚠️ Awaiting tenant payment</Txt>
      <View>
        <Txt xxx bold>
          £{formatCurrency(tenancyData.payments.depositAmountPaid)}
        </Txt>
        <Txt caption>
          /£{formatCurrency(tenancyData.payments.depositAmount)}
        </Txt>
      </View>
      <FlexContainer column gapHalf>
        {tenantsData.map((t) => {
          return (
            <TenantDepositDetails
              key={t.id}
              fullName={t.data.fullName}
              actionLabel={t.data.payments?.depositPlaidUid ? 'PAID' : 'DUE'}
              emailAddress={t.data.emailAddress}
              mobileNumber={t.data.mobileNumber}
              isDone={t.data.payments?.depositPlaidUid}
            />
          );
        })}
      </FlexContainer>
      <Txt regular>
        A landlord should request a deposit payment before a tenancy starts to
        assure both parties of their commitments throughout a tenancy.
      </Txt>
      <Txt regular>
        A deposit must be stored in a government approved tenancy deposit scheme
        like TDS.
      </Txt>
      <a
        href={tdsLink}
        target="_blank"
        className={styles.ButtonLink}
        rel="noreferrer"
      >
        <Button success flex>
          What is TDS?
        </Button>
      </a>
      <Txt regular>
        When you receive your tenants deposit you have 30 days to pay it into a
        government approved tenancy deposit scheme.
      </Txt>
      <Button success onClick={handleSendDepositReminder} disabled={isLoading}>
        Send Deposit Reminder
      </Button>
    </FlexContainer>
  );
};

DepositNotLinked.displayName = 'DepositNotLinked';

export default observer(DepositNotLinked);
